const defaultFilterModel = {
    pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
    modelFilter: {
        userName: ""
    },
    sortFilter: {}
}

 const getDefaultFilter = () => Object.assign({}, defaultFilterModel);

 export {getDefaultFilter};
